import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpClient.service';
import { Observable } from 'rxjs';
import { jobDesignationApi } from '../../constants/job-designation-api';
import { PaginationType } from '../../interfaces/pagination/pagination-type';

@Injectable({
    providedIn: 'root',
})
export class JobDesignationService {
    constructor(private httpClientService: HttpClientService) {}

    getJobDesignation(pagination: PaginationType): Observable<any> {
        return this.httpClientService.get(`${jobDesignationApi.getJobDesignation}?skip=${pagination.skip}&limit=${pagination.limit}`);
    }

    postJobDesignation(payload: any): Observable<any> {
        return this.httpClientService.post(
            jobDesignationApi.createJobDesignation,
            payload
        );
    }

    editJobDesignation(payload: any): Observable<any> {
        return this.httpClientService.put(
            jobDesignationApi.editJobDesignation,
            payload
        );
    }

    deleteJobDesignation(): Observable<any> {
        return this.httpClientService.delete(
            jobDesignationApi.deleteJobDesignation
        );
    }
}
